/**
 * What the closed dropdown says. An empty list only means "no workspaces"
 * once the session is confirmed and the load is done: signed out, it says so,
 * and while either is pending it says it is loading.
 */
export function emptyPlaceholder(
  count: number,
  isAuthenticated: boolean,
  isReady: boolean,
  loading: boolean,
  isCompact: boolean,
): string {
  if (count > 0) return "Select workspace";
  if (!isAuthenticated)
    return isCompact ? "Signed out" : "Sign in to see workspaces";
  if (!isReady || loading) return "Loading…";
  return isCompact ? "None" : "No Workspaces Configured";
}
